<template>
  <div class="panel-simple mt-4">
    <SectionTitle
      v-if="hasTitle"
      :has-line="true"
      :content="centerTitleHeader"
      class="mt-4"
    />
    <div v-if="hasRegularFiles" class="panel-row-parent">
      <document-layout
        v-for="(fil, index) in file.tempFileUpload.files"
        :key="`${index}-${fil.name}`"
        :actions="getActions(index, fil, file.tempFileUpload.files)"
        :in-server="fil.inServer"
        :node="index"
      >
        <div slot="firstColumn">
          <div class="d-flex flex-column">
            <span class="data-title">Fecha:</span>
            <span class="data-content">{{ fil.createdDate | date }}</span>
          </div>
        </div>
        <div slot="secondColumn">
          <div class="d-flex flex-column">
            <span class="data-title">Tipo:</span>
            <span class="data-content">
              {{
                fil.documentTypeName
                  ? fil.documentTypeName
                  : file.types.find(
                      (x) => x.id == file.tempFileUpload.types[index]
                    ).name
              }}
            </span>
          </div>
        </div>
        <div slot="thirdColumn">
          <div class="d-flex flex-column">
            <span class="data-title">Título:</span>
            <span class="data-content">{{ fil.name }}</span>
          </div>
        </div>
        <div slot="fourthColumn">
          <div class="d-flex flex-column">
            <span class="data-title">Añadido por:</span>
            <span class="data-content">
              {{ fil.userFullName }} - {{ fil.userName }}
            </span>
          </div>
        </div>
        <div v-if="fil.pei" slot="fifthColumn">
          <div class="d-flex flex-column">
            <span class="data-title">Número de PEI:</span>
            <span class="data-content">{{ fil.pei }}</span>
          </div>
        </div>
        <div v-if="fil.pei" slot="sixthColumn">
          <div class="d-flex flex-column">
            <span class="data-title">Estatus del PEI:</span>
            <div class="w-balloon-status text-left">
              <custom-balloon
                :icon="`fas fa-circle ${getPeiColor(fil.peiStatus)}`"
                :text="fil.peiStatus"
              />
            </div>
          </div>
        </div>
      </document-layout>
      <div
        v-if="!disabled && message"
        class="col-12 text-right bg-white pt-4 pr-0"
      >
        <div class="row">
          <div class="col-md-auto order-md-2">
            <ActionButton
              id="btnAddDocument"
              variant="success"
              i="fas fa-file-plus"
              :responsive="false"
              @click="showUpload = true"
            >
              A&ntilde;adir
            </ActionButton>
          </div>
          <div class="col text-left order-md-1 pt-xs-4 message">
            <p>
              <span class="fal fa-exclamation-circle" />
              <span v-text="message" />
            </p>
          </div>
        </div>
      </div>
      <div
        v-if="!disabled && !message"
        class="col-12 text-right bg-white pt-4 pr-0"
      >
        <ActionButton
          v-if="showAddMore"
          id="btnAddDocument"
          variant="success btn-block-xs-only"
          i="fas fa-file-plus"
          @click="showUpload = true"
        >
          A&ntilde;adir
        </ActionButton>
      </div>
    </div>

    <div v-if="!showUpload && !hasRegularFiles">
      <div class="bg-light-gray border-radius--light text-center col-12">
        <button
          id="btnAddBackupDocument"
          class="btn bg-light-white pt-1 mb-3 mt-3 col-12 col-md-6 col-lg-6"
          :disabled="disabled"
          @click="showUpload = !showUpload"
        >
          <i class="fas fa-file-plus pr-4 text-green" />
          <span class="text-button-add-document">
            Presione aqu&iacute; para anejar documentos
          </span>
        </button>
      </div>
    </div>

    <div v-else-if="showUpload">
      <div class="container-fluid" />

      <ValidationObserver ref="observer" novalidate>
        <div class="panel-row-without-selector-res py-4">
          <div class="col-md-3 col-sm-12 text-left">
            <ValidationProvider v-slot="{ errors }" rules="required">
              <CustomDropDown
                id="ddlTypeSelected"
                v-model="file.typeSelected"
                label="Tipo:"
                placeholder="Seleccione"
                required="required"
                fieldkey="id"
                fieldname="name"
                :options="getDocumentTypes"
                :error="errors[0]"
                :custom-error-msg="errorMsgTypeDocument"
                @input="setSelected"
              />
            </ValidationProvider>
          </div>
          <div class="col-md-6 col-sm-12 text-left pt-xs-4">
            <ValidationProvider
              v-slot="{ errors }"
              class="w-100"
              name="Documento"
              rules="required"
            >
              <CustomFileInput
                id="txtFileAttachment"
                ref="fileUpload"
                v-model="file.attachment"
                label="Documento:"
                :accept="file.allowedFiles"
                required
                label-position="left"
                display-style="normal"
                :error="errors[0]"
                :custom-error-msg="errorMsgFileRequired"
                :on-download="downloadAttachment"
              />
            </ValidationProvider>
          </div>
          <div
            class="align-items-end d-flex justify-content-end col-12 col-md-2 offset-md-10 pr-2 pt-xs-4"
          >
            <ActionButton
              variant="outline-danger m-1"
              i="fas fa-times-circle"
              :responsive="true"
              @click="cancelDocument"
            >
              Cancelar
            </ActionButton>
            <ActionButton
              variant="success m-1"
              i="fas fa-file-plus"
              :responsive="true"
              @click="save"
            >
              Añadir
            </ActionButton>
          </div>
        </div>
      </ValidationObserver>
    </div>

    <div
      v-if="amendmentFile.tempFileUpload.files.length > 0"
      class="panel-row-parent"
    >
      <SectionTitle
        :has-line="true"
        content="Documentos de Enmienda"
        class="mt-4"
      />

      <document-layout
        v-for="(fil, index) in amendmentFile.tempFileUpload.files"
        :key="`${index}-${fil.name}-amendment`"
        :actions="getActions(index, fil, amendmentFile.tempFileUpload.files)"
        :in-server="fil.inServer"
        :node="index"
      >
        <div slot="firstColumn">
          <div class="d-flex flex-column">
            <span class="data-title">Fecha:</span>
            <span class="data-content">{{ fil.createdDate | date }}</span>
          </div>
        </div>
        <div slot="secondColumn">
          <div class="d-flex flex-column">
            <span class="data-title">Tipo:</span>
            <span class="data-content">
              {{
                fil.documentTypeName
                  ? fil.documentTypeName
                  : file.types.find(
                      (x) => x.id == amendmentFile.tempFileUpload.types[index]
                    )?.name
              }}
            </span>
          </div>
        </div>
        <div slot="thirdColumn">
          <div class="d-flex flex-column">
            <span class="data-title">Título:</span>
            <span class="data-content">{{ fil.name }}</span>
          </div>
        </div>
        <div slot="fourthColumn">
          <div class="d-flex flex-column">
            <span class="data-title">Añadido por:</span>
            <span class="data-content">
              {{ fil.userFullName }} - {{ fil.userName }}
            </span>
          </div>
        </div>
        <div v-if="fil.pei" slot="fifthColumn">
          <div class="d-flex flex-column">
            <span class="data-title">Número de PEI:</span>
            <span class="data-content">{{ fil.pei }}</span>
          </div>
        </div>
        <div v-if="fil.pei" slot="sixthColumn">
          <div class="d-flex flex-column">
            <span class="data-title">Estatus del PEI:</span>
            <div class="w-balloon-status text-left">
              <custom-balloon
                :icon="`fas fa-circle ${getPeiColor(fil.peiStatus)}`"
                :text="fil.peiStatus"
              />
            </div>
          </div>
        </div>
      </document-layout>
    </div>
  </div>
</template>

<style scoped src="@/assets/css/component/panel-simple.css"></style>

<script>
import {
  CustomDropDown,
  CustomBalloonLight as CustomBalloon,
} from '@/components/common';
import ActionButton from 'ActionButton';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import DocumentLayout from './DocumentLayout';
import general from '@/services/pei/general';
import CustomAlert from '@/mixin/alert.mixin';
import SectionTitle from 'SectionTitle';
import CustomFileInput from 'CustomFileInput';
import { deleteDocument } from '@/services/api/tapRequest.api';

export default {
  name: 'Document',
  components: {
    CustomFileInput,
    ValidationObserver,
    ValidationProvider,
    DocumentLayout,
    ActionButton,
    CustomDropDown,
    SectionTitle,
    CustomBalloon,
  },
  props: {
    documents: {
      type: Object,
      default: () => null,
    },
    documentTypes: {
      type: Array,
      default: () => [],
    },
    invalidTypes: {
      type: Array,
      default: () => [],
    },
    errorMsgs: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
    centerTitleHeader: {
      type: String,
      default: 'Documentos de Consulta',
    },
    message: {
      type: String,
      default: '',
    },
    hasTitle: {
      type: Boolean,
      default: () => true,
    },
    showAddMore: {
      type: Boolean,
      default: () => true,
    },
    separateAmendmentDocuments: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      file: {
        name: '',
        types: this.documentTypes ? this.documentTypes : [],
        allowedFiles: '.pdf',
        attachment: null,
        tempFileUpload: {
          files: [],
          types: [],
        },
        typeSelected: null,
      },
      amendmentFile: {
        name: '',
        types: this.documentTypes ? this.documentTypes : [],
        allowedFiles: '.pdf',
        attachment: null,
        tempFileUpload: {
          files: [],
          types: [],
        },
        typeSelected: null,
      },
      modal: {
        icon: 'fa fa-exclamation-triangle',
        size: 200,
        title: 'Alerta!',
        type: 'confirm',
        message: '',
        checkbox: {
          isRequired: false,
        },
        success: () => {},
        cancel: () => {},
      },
      showUpload: false,
      showMessageDocumentType: false,
    };
  },
  created() {
    this.$emit('input', this.documents);
  },
  methods: {
    getActions(node, fil, documents) {
      let documentActions = [
        {
          btnClass: 'outline-success',
          icon: 'fas fa-file-download green-icon',
          label: 'Descargar',
          click: () => this.downloadFile(documents, node),
        },
      ];

      const canDelete = fil.pei == null && !fil.readOnly;

      if (canDelete) {
        documentActions.push({
          btnClass: 'outline-danger',
          icon: 'fas fa-times-circle text-red',
          label: 'Eliminar',
          click: () => this.drop(node, documents),
        });
      }

      return documentActions;
    },
    cancelDocument() {
      this.clear();
      this.showUpload = false;
      this.$emit('onCancel');
    },
    setSelected(data) {
      this.file.typeSelected = data;
    },
    async save() {
      let isValid = await this.$refs.observer.validate();
      if (!isValid) return;

      let newFile = {
        file: this.file.attachment,
        name: this.file.attachment.name,
        inServer: false,
        documentTypeName: this.file.typeSelected.name,
        documentTypeId: this.file.typeSelected.id,
      };

      if (this.amendmentFile.tempFileUpload.files.length > 0) {
        this.amendmentFile.tempFileUpload.files.push(newFile);
        this.amendmentFile.tempFileUpload.types.push(this.file.typeSelected.id);
      } else {
        this.file.tempFileUpload.files.push(newFile);
        this.file.tempFileUpload.types.push(this.file.typeSelected.id);
      }

      this.$emit('files', {
        files: [
          ...(this.file.tempFileUpload?.files || []),
          ...(this.amendmentFile.tempFileUpload?.files || []),
        ],
        types: [
          ...(this.file.tempFileUpload?.types || []),
          ...(this.amendmentFile.tempFileUpload?.types || []),
        ],
      });

      this.showUpload = false;

      this.clear();
    },
    clear() {
      this.file.typeSelected = null;
      this.file.attachment = null;
    },
    getPeiColor(status) {
      let statusClass = '';
      //ECG:Esto se debe basar en id de estatus de pei
      switch (status) {
        case 'Borrador':
          statusClass = 'badge-erase';
          break;
        case 'Cancelado':
          statusClass = 'badge-cancel';
          break;
        case 'Completado':
          statusClass = 'badge-complete';
          break;
        case 'Completado - Controversia':
          statusClass = 'badge-complete';
          break;
        case 'Firmado':
          statusClass = 'badge-signed';
          break;
        case 'Incompleto':
          statusClass = 'badge-incomplete';
          break;
        case 'Completado – Pendiente Fondos':
          statusClass = 'badge-pending';
          break;
        case 'Firmado Parcial - Pendiente de Fondos':
          statusClass = 'badge-partial';
          break;
        case 'Firmado - Controversia':
          statusClass = 'badge-partial';
          break;
        case 'Propuesta de PEI - Rechazada':
          statusClass = 'badge-pending-funds';
          break;
      }

      return statusClass;
    },
    downloadAttachment(attachmentId) {
      return general.downloadDocumentByAttachmentId(attachmentId);
    },
    downloadFile(documents, node) {
      let file = documents[node];
      if (file.pei && file.isReport) {
        let self = this;

        let promise = new Promise((resolve) => {
          self
            .$ApiGet('/api/report/pei/' + file.pei)
            .then((res) => {
              self.report = res.data;
              general.documentDownloadReport(
                self.report.content,
                self.report.filename
              );
              resolve(res.data);
            })
            .catch((err) => {
              self.response = err;
            });
        });
        return promise;
      } else if (!file.inServer) {
        general.documentDownloadLocalFile(file.file);
      } else {
        let uri = `api/documents/downloaddocument?id=${file.id}`;

        this.$ApiGet(uri).then((response) => {
          general.downloadDocument(response.data);
        });
      }
    },
    async delete(node, documents) {
      let file = documents[node];

      if (file.id) {
        await deleteDocument(file.id).then(() => {
          documents.splice(node, 1);
          this.emitFiles();
        });
      } else {
        documents.splice(node, 1);
        this.emitFiles();
      }
    },
    async drop(node, documents) {
      let alertResponse = await CustomAlert.methods.ShowCancelModal(
        'Atención',
        this.errorMsgConfirmDeleteDocument,
        'Sí',
        'No'
      );

      if (alertResponse) {
        this.delete(node, documents);
      }
    },
    loadExistingDocuments() {
      if (this.documents != null) {
        let { files, types } = this.documents;
        this.file.tempFileUpload.files =
          files.filter(
            (c) =>
              !this.separateAmendmentDocuments ||
              c.isAmendmentDocument == null ||
              !c.isAmendmentDocument
          ) || [];
        this.file.tempFileUpload.types = types || [];

        this.amendmentFile.tempFileUpload.files = this
          .separateAmendmentDocuments
          ? files.filter((c) => c.isAmendmentDocument)
          : [];
        this.amendmentFile.tempFileUpload.types = this
          .separateAmendmentDocuments
          ? types || []
          : [];
      }
    },
    emitFiles() {
      const files = [
        ...(this.file.tempFileUpload?.files || []),
        ...(this.amendmentFile.tempFileUpload?.files || []),
      ];

      this.$emit('files', {
        files,
        types: files.map((x) => x.documentType || x.documentTypeId),
      });
    },
  },
  // watch: {
  //   'file.tempFileUpload.files': {
  //     immediate: true,
  //     deep: true,
  //     handler(newValue) {
  //       if (newValue) this.file.tempFileUpload.files = newValue;
  //     },
  //   },
  // },
  computed: {
    hasRegularFiles() {
      return this.file.tempFileUpload.files.length > 0;
    },
    errorMsgTypeDocument() {
      return 'Favor seleccionar el tipo de documento.';
    },
    errorMsgFileRequired() {
      return 'El documento no existe.';
    },
    errorMsgConfirmDeleteDocument() {
      return '¿Está seguro que desea eliminar el documento?';
    },
    getDocumentTypes() {
      const validDocumentTypes = this.documentTypes.filter(
        (x) => !this.invalidTypes.includes(x.id)
      );

      return validDocumentTypes;
    },
  },
  async mounted() {
    this.loadExistingDocuments();
  },
};
</script>

<style scope>
.zi-100 {
  z-index: 100;
}

.orange-icon {
  color: #ff7058;
}
.hidden {
  display: none;
}
.p-title {
  text-align: left;
  font-family: 'Lato';
  font-size: 16px;
}
.p-title.title-header {
  font-weight: bold;
}
.info > .center-box {
  float: left;
}
.danger-text {
  color: #e85c5c;
}
.green-icon {
  color: #2db782;
}
.buttons-container {
  margin-top: 27px;
}
.bg-add-panel {
  background-color: #fafafa;
  padding: 30px;
}
.w-balloon-status {
  width: auto;
}

/************ CUSTOM BADGES *************/
.badges {
  color: black;
  font-size: 16px;
  width: 100%;
  height: 42px;
  line-height: 20px;
  border-radius: 20px;
  padding: 10px;
}
.badge-erase {
  color: #fcc9c8;
}
.badge-cancel {
  color: #d5b89a;
}
.badge-complete {
  color: #f8ea80;
}
.badge-signed {
  color: #a3e5b3;
}
.badge-incomplete {
  color: #d5b89a;
}
.badge-waiting {
  color: #a7e6dc;
}
.badge-partial {
  color: #a3e5b3;
}
.badge-pending-funds {
  color: #ddb3d7;
}
.badge-pending {
  color: #f8ea80;
}
.outline-success {
  color: #2db782 !important;
  background-color: #ffffff;
  border-color: #2db782;
  outline: none;
}

.outline-success:hover {
  color: #fff !important;
  background-color: #2db782;
}

.outline-success:hover > i {
  color: #fff !important;
}

.outline-danger {
  color: #c9545e;
  background-color: #ffffff;
  border-color: #c9545e;
  outline: none;
}

.outline-danger:hover {
  color: #fff !important;
  background-color: #c9545e;
}

.outline-danger:hover > i {
  color: #fff !important;
}

.w-balloon-status > div {
  border: none !important;
}
@media (max-width: 575px) {
  .pt-xs-4,
  .py-xs-4 {
    padding-top: 1.5rem !important;
  }

  .btn-block-xs-only {
    display: block;
    width: 100%;
  }
}
.message {
  color: #707070;
}
.justify-content-center {
  -webkit-box-pack: left !important;
  -ms-flex-pack: left !important;
  justify-content: left !important;
}
</style>
